import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Nav from './ui/nav/Nav';
import AllTripsPage from './pages/AllTripsPage';
import AdminPage from './pages/AdminPage';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import LoginPage from './pages/LoginPage';
import ErrorBoundary from './pages/ErrorBoundary';
import RedirectHandler from './config/RedirectHandler';
import AuthWrapper from './components/AuthWrapper';
import ProtectedRoute from './routing/ProtectedRoute';
import { DataProvider } from './data/DataContext';

function App(): React.ReactElement {
    return (
        <Router>
            <AuthenticatedTemplate>
                <AuthWrapper>
                    <DataProvider>
                        <div className="App">
                            <Nav />
                            <div className="content">
                                <ErrorBoundary>
                                    <Routes>
                                        <Route path="/trips" element={<AllTripsPage />} />
                                        <Route 
                                            path="/admin" 
                                            element={
                                                <ProtectedRoute>
                                                    <AdminPage />
                                                </ProtectedRoute>
                                            } 
                                        />
                                        <Route path="/redirect" element={<RedirectHandler />} />
                                        <Route path="*" element={<Navigate to="/trips" />} />
                                    </Routes>
                                </ErrorBoundary>
                            </div>
                        </div>
                    </DataProvider>
                </AuthWrapper>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <LoginPage />
            </UnauthenticatedTemplate>
        </Router>
    );
}

export default App;